export default __webpack_public_path__ + "static/media/pro-project.bb709b7d.png";